import { SliceCreator } from '../TrainingState';
import {
  SaveAnswersMutation,
  SaveAnswersMutationVariables,
  SaveAnswersDocument
} from '~/data';
import { client } from '~/data/client';
import { Sequence } from '~/training/state';

export interface QuestionAnswersSlice {
  saveQuestionAnswers: (questionFieldId: string, sequenceId?: string) => void;
}

/**
 * Save question answers on the back-end
 * @param variables The GraphQL query variables
 * @returns The values that have been updated
 */
export async function saveQuestionAnswers(variables: {
  learnerTrainingUuid: string;
  chapterSequenceId: string;
  questionFieldId: string;
}) {
  const result = await client.mutate<
    SaveAnswersMutation,
    SaveAnswersMutationVariables
  >({
    mutation: SaveAnswersDocument,
    variables
  });

  if (result.errors?.length || result.data?.saveAnswers?.errors.length) {
    throw new Error('Error saving settings...');
  }

  return variables;
}

export const createSaveQuestionAnswersRequest: SliceCreator<
  QuestionAnswersSlice
> = (set, get) => {
  /**
   * @param newValues contain data about question
   */
  async function storeQuestionAnswers(
    newValues: Partial<SaveAnswersMutationVariables>
  ) {
    const { learnerTrainingId, chapterSequenceId } = get();

    return await saveQuestionAnswers({
      learnerTrainingUuid: learnerTrainingId,
      chapterSequenceId: chapterSequenceId,
      questionFieldId: '',
      ...newValues
    });
  }

  return {
    saveQuestionAnswers: (questionFieldId: string, sequenceId?: string) => {
      const { items, activeItemPosition } = get();

      const index = items.findIndex(
        i => i.kind === 'sequence' && i.position === activeItemPosition
      );
      // Null-safe resolution of the chapterSequenceId
      let chapterSeqId: string | undefined;

      if (sequenceId) {
        const seq = items.find(
          i => i.kind === 'sequence' && i.id === sequenceId
        ) as Sequence | undefined;
        chapterSeqId = seq?.chapterSequenceId;
      } else if (index !== -1) {
        const seq = items[index] as Sequence | undefined;
        chapterSeqId = seq?.chapterSequenceId;
      }

      if (!chapterSeqId) {
        // Silently ignore if we cannot resolve a chapter sequence id.
        return;
      }

      storeQuestionAnswers({
        questionFieldId,
        chapterSequenceId: chapterSeqId
      }).then();

      // if (chapterSequenceId) {
      //   storeQuestionAnswers({ questionFieldId }).then();
      // }
    }
  };
};
